import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useMediaQuery } from 'react-responsive'
import { useLocation, useNavigate, useParams } from 'react-router-dom'

import { finishQuiz, resultSelector } from '@/services/slices/questionSlice'
import { AppDispatch } from '@/store'
import Button from '@/ui/Button/Button'
import Logo from '@/ui/icons/Logo'
import { getResult } from '@/utils/api'
import resultPhrases from '@/utils/resultPhrases'
import classNames from 'classnames'

import styles from './styles.module.scss'

import ResultCard from './componets/ResultCard/ResultCard'

const ResultPage = () => {
  const isDesktop = useMediaQuery({ minWidth: 1440 })
  const isMobile = useMediaQuery({ maxWidth: 767 })

  const { corrects } = useSelector(resultSelector)
  const { id } = useParams()

  const navigate = useNavigate()

  const dispatch = useDispatch<AppDispatch>()

  const { title, description, text, textCopy, titleCopy } =
    resultPhrases(corrects)

  useEffect(() => {
    dispatch(getResult(Number(id)))
  }, [dispatch, id])

  const onLanding = () => {
    dispatch(finishQuiz())
  }

  const onQuiz = useCallback(() => {
    window.scrollTo({ top: 0, left: 0 })

    navigate('/quiz')
  }, [navigate])

  const { search } = useLocation()

  const isCopy = search.includes('copy=true')

  return (
    <div className={styles.result}>
      <div className={styles.container}>
        <a href="https://2gis.ru" target="_blank" rel="noopener noreferrer">
          <Logo />
        </a>
        <div className={styles.container_info}>
          <div className={styles.titles}>
            <h1
              className={classNames(
                'text',
                isDesktop ? 't-header-h4' : 't-header-h3',
                'text_color_primary',
                styles.heading,
              )}
            >
              {isCopy ? titleCopy : title}
            </h1>
            {!isCopy && (
              <p
                className={classNames(
                  'text',
                  't-body-med',
                  'text_color_primary',
                  styles.heading,
                )}
              >
                {description}
              </p>
            )}
          </div>

          <ResultCard text={isCopy ? textCopy : text} />

          <div className={styles.button_wrapper}>
            {isCopy ? (
              <Button type="accent" size="fullsize" onClick={onQuiz}>
                Пройти квиз
              </Button>
            ) : (
              <Button
                type="accent"
                size="fullsize"
                linkTo="/#records"
                onClick={onLanding}
                className={styles.quiz_button}
              >
                Посмотреть все рекорды
              </Button>
            )}
            {isCopy && (
              <Button
                type={isMobile ? 'primary' : 'secondary'}
                withBorder
                size="fullsize"
                linkTo="/#records"
                onClick={onLanding}
                className={styles.quiz_button}
              >
                Сразу к рекордам
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default ResultPage
